import React, { useEffect, useState } from "react";
import "../Testimonials/Testimonials.css";

const testimonialsData = [
  {
    text: "The service was outstanding and the ambiance was simply perfect. Highly recommended!",
    name: "Anjali Mehra",
    location: "Mumbai, India",
  },
  {
    text: "Amazing experience! The team was professional, and the food was delicious.",
    name: "Ravi Kumar",
    location: "Bangalore, India",
  },
  {
    text: "Top-notch service with a warm, welcoming atmosphere. Will visit again!",
    name: "Priya Sharma",
    location: "Delhi, India",
  },
  {
    text: "Exceptional service and quality. Truly one of the best dining experiences I've had.",
    name: "Rahul Verma",
    location: "Pune, India",
  },
];

const Testimonials = () => {
  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false); // trigger fade-out
      setTimeout(() => {
        setIndex((prevIndex) => (prevIndex + 1) % testimonialsData.length);
        setFade(true); // trigger fade-in
      }, 600);
    }, 6000);

    return () => clearInterval(interval);
  }, []);

  const currentTestimonial = testimonialsData[index];

  return (
    <section className="testimonials-t">
     
      <div className="overlay-t">
      <div className="testimonial-header-t">
            <h2 className="testimonial-heading-t">Hear from Our <span>Happy</span>  Clients! </h2>
            <p className="testimonial-subtext-t">
  We value every customer and strive to provide the best experience possible. Our team works tirelessly to exceed expectations and create lasting relationships. Customer satisfaction is our top priority, and we are always ready to assist with any need.
</p>
          </div>
        <div className="testimonial-wrapper-t">
         

          <div className={`testimonial-content-t ${fade ? "fade-in-t" : "fade-out-t"}`}>
            <p className="testimonial-text-t">“{currentTestimonial.text}”</p>
            <h3 className="testimonial-name-t">{currentTestimonial.name}</h3>
            <p className="testimonial-location-t">{currentTestimonial.location}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
